export const formatClientContractStatus = (status: string = "") => {
  switch (status) {
    case "pending_signature":
      return "Pendente";
    case "signed_signature":
      return "Assinado";
    case "canceled_signature":
      return "Cancelado";
    case "not_signed_signature":
      return "Não assinado";
    default:
      return "Outro";
  }
};
